import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import PageWrapper from '../components/wrapper/FlexiblePageWrapper';
import GhostWrapper from '../components/wrapper/GhostWrapper';
import HomeGhosts from './../components/ghosts/HomeGhosts';
import Header from './../components/general/Header';
import Title from './../components/text/Title';
import Subtitle from './../components/text/Subtitle';
import Button from './../components/general/Button';
import Footer from './../components/general/Footer';

function Home() {
  const { t } = useLanguage();

  return (
    <PageWrapper>
      <GhostWrapper>
        <Header text="Why is autocomplete so biased" />
        <main className="w-full max-w-4xl mx-auto sm:px-4 pt-40 pb-28 flex flex-col items-center gap-6">
          <Title size="small" text={t('title')} />
          <Subtitle text={t('gameGuideTitle')} />
          <br />
          <article className="w-full px-8 text-sm">
            <Subtitle size="small" text={t('gameGuideSubtitle1')} color="red" />
            <p>{t('gameGuidetext11')}</p>
            <br />
            <p>{t('gameGuidetext12')}</p>
          </article>

          <article className="w-full px-8 text-sm">
            <Subtitle size="small" text={t('gameGuideSubtitle2')} color="blue" />
            <p>{t('gameGuidetext21')}</p>
            <ul className="my-2 list-disc pl-6 space-y-1">
              <li>{t('gameGuidetext22')}</li>
              <li>{t('gameGuidetext23')}</li>
            </ul>
            <p>
              {t('gameGuidetext241')} <span className="font-bold">{t('gameGuidetext242')}</span>{' '}
              {t('gameGuidetext243')} <span className="font-bold">{t('gameGuidetext244')}</span>
              {t('gameGuidetext245')}
            </p>
          </article>

          <article className="w-full px-8 text-sm">
            <Subtitle size="small" text={t('gameGuideSubtitle3')} color="green" />
            <p>{t('gameGuidetext31')}</p>
          </article>

          <article className="w-full px-8 text-sm">
            <Subtitle size="small" text={t('gameGuideSubtitle4')} color="yellow" />
            <p>{t('gameGuidetext41')}</p>
          </article>

          <article className="w-full px-8 text-sm">
            <Subtitle size="small" text={t('gameGuideSubtitle5')} color="red" />
            <p>{t('gameGuidetext51')}</p>
          </article>

          <article className="w-full px-8 text-sm">
            <Subtitle size="small" text={t('gameGuideSubtitle6')} color="blue" />
            <p>{t('gameGuidetext61')}</p>
            <ul className="my-2 list-disc pl-6 space-y-1">
              <li>{t('gameGuidetext621')}</li>
              <li>{t('gameGuidetext622')}</li>
              <li>{t('gameGuidetext623')}</li>
              <li>{t('gameGuidetext624')}</li>
            </ul>
          </article>
          <br />
          <Link to="/">
            <Button text={t('goHome')} />
          </Link>
        </main>
      </GhostWrapper>
      <HomeGhosts />
      <Footer />
    </PageWrapper>
  );
}

export default Home;
